<div
  *ngIf="(programNode?.message && !isDependency) || programNode?.messageValue"
  class="program-output card"
>
  <h4
    *ngIf="
      programNode?.labelText &&
      programNode?.labelText !== programNode?.messageValue
    "
    [innerHTML]="programNode?.labelText"
  ></h4>
  <span
    class="label-highlight"
    *ngIf="programNode?.description"
    [innerHTML]="programNode?.description"
  ></span>
  <mec-dynamic-html
    *ngIf="programNode?.messageValue"
    [content]="programNode?.messageValue"
  ></mec-dynamic-html>
  <!-- <span
    *ngIf="programNode?.messageValue"
    [innerHTML]="programNode?.messageValue"
  ></span> -->
  <span
    *ngIf="!programNode?.messageValue"
    [innerHTML]="programNode?.message"
  ></span>
</div>
